import React from 'react';

const TimerIcon: React.FC = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.9999 4.60229C6.01657 4.60229 2.7749 7.84396 2.7749 11.8273C2.7749 15.8106 6.01657 19.0606 9.9999 19.0606C13.9832 19.0606 17.2249 15.819 17.2249 11.8356C17.2249 7.8523 13.9832 4.60229 9.9999 4.60229ZM10.6249 11.5606C10.6249 11.9023 10.3416 12.1856 9.9999 12.1856C9.65824 12.1856 9.3749 11.9023 9.3749 11.5606V7.39396C9.3749 7.05229 9.65824 6.76896 9.9999 6.76896C10.3416 6.76896 10.6249 7.05229 10.6249 7.39396V11.5606Z"
      fill="currentColor"
    />
    <path
      d="M12.4084 3.60232H7.5917C7.25837 3.60232 6.9917 3.33565 6.9917 3.00232C6.9917 2.66898 7.25837 2.39398 7.5917 2.39398H12.4084C12.7417 2.39398 13.0084 2.66065 13.0084 2.99398C13.0084 3.32732 12.7417 3.60232 12.4084 3.60232Z"
      fill="currentColor"
    />
  </svg>
);

export default TimerIcon;
